<template>
  <div class="bg_color_1">
    <div class="container margin_80_55">
      <div class="main_title_2">
        <span><em></em></span>
        <h3>News and Events</h3>
        <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <a class="box_news" href="#0">
            <figure>
              <img src="../../public/frontend/img/news_home_1.jpg" alt="" />
              <figcaption><strong>28</strong>Dec</figcaption>
            </figure>
            <ul>
              <li>Mark Twain</li>
              <li>20.11.2017</li>
            </ul>
            <h4>Pri oportere scribentur eu</h4>
            <p>
              Cu eum alia elit, usu in eius appareat, deleniti sapientem
              honestatis eos ex. In ius esse ullum vidisse....
            </p>
          </a>
        </div>
        <!-- /box_news -->
        <div class="col-lg-6">
          <a class="box_news" href="#0">
            <figure>
              <img src="../../public/frontend/img/news_home_2.jpg" alt="" />
              <figcaption><strong>28</strong>Dec</figcaption>
            </figure>
            <ul>
              <li>Jhon Doe</li>
              <li>20.11.2017</li>
            </ul>
            <h4>Duo eius postea suscipit ad</h4>
            <p>
              Cu eum alia elit, usu in eius appareat, deleniti sapientem
              honestatis eos ex. In ius esse ullum vidisse....
            </p>
          </a>
        </div>
        <!-- /box_news -->
        <div class="col-lg-6">
          <a class="box_news" href="#0">
            <figure>
              <img src="../../public/frontend/img/news_home_3.jpg" alt="" />
              <figcaption><strong>28</strong>Dec</figcaption>
            </figure>
            <ul>
              <li>Luca Robinson</li>
              <li>20.11.2017</li>
            </ul>
            <h4>Elitr mandamus cu has</h4>
            <p>
              Cu eum alia elit, usu in eius appareat, deleniti sapientem
              honestatis eos ex. In ius esse ullum vidisse....
            </p>
          </a>
        </div>
        <!-- /box_news -->
        <div class="col-lg-6">
          <a class="box_news" href="#0">
            <figure>
              <img src="../../public/frontend/img/news_home_4.jpg" alt="" />
              <figcaption><strong>28</strong>Dec</figcaption>
            </figure>
            <ul>
              <li>Paula Rodrigez</li>
              <li>20.11.2017</li>
            </ul>
            <h4>Id est adhuc ignota delenit</h4>
            <p>
              Cu eum alia elit, usu in eius appareat, deleniti sapientem
              honestatis eos ex. In ius esse ullum vidisse....
            </p>
          </a>
        </div>
        <!-- /box_news -->
      </div>
      <!-- /row -->
      <p class="btn_home_align">
        <a href="blog.html" class="btn_1 rounded">View all news</a>
      </p>
    </div>
    <!-- /container -->
  </div>
  <!-- /bg_color_1 -->
</template>

<script>
export default {};
</script>
